import React, { createContext, useState } from "react";
import { ShowToast, Severty } from "../helper/toast";
import { kycAPI } from "../services/api";

export const KYCContext = createContext();

export const KYCProvider = ({ children }) => {
  const [isLoading, setLoading] = useState(false);

  // Submit KYC
  const submitKYC = async (formData) => {
    try {
      setLoading(true);

      const response = await kycAPI.submitKYC(formData);

      if (
        (response?.status === 200 || response?.status === 201) &&
        response?.data
      ) {
        ShowToast("KYC submitted successfully!", Severty.SUCCESS);
        return { success: true, data: response.data, status: response.status };
      } else {
        console.warn("Failed to submit KYC:", response?.message);
        ShowToast(response?.message || "Failed to submit KYC", Severty.ERROR);
        return {
          success: false,
          error: response?.message,
          status: response?.status,
        };
      }
    } catch (error) {
      const errorMessage =
        error?.message ||
        error?.error ||
        "Failed to submit KYC. Please try again.";
      ShowToast(errorMessage, Severty.ERROR);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  // Fetch KYC
  const fetchKYC = async () => {
    try {
      setLoading(true);
      const response = await kycAPI.fetchKYC(); // your API call to get KYC

      if (response?.status === 200 && response?.data) {
        return { success: true, data: response.data, status: response.status };
      } else {
        console.warn("Failed to fetch KYC:", response?.message);
        // ShowToast(response?.message || "Failed to fetch KYC", Severty.ERROR);
        return {
          success: false,
          error: response?.message,
          status: response?.status,
        };
      }
    } catch (error) {
      const errorMessage =
        error?.message ||
        error?.error ||
        "Failed to fetch KYC. Please try again.";
      // ShowToast(errorMessage, Severty.ERROR);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  return (
    <KYCContext.Provider
      value={{
        isLoading,
        submitKYC,
        fetchKYC,
        setLoading,
      }}
    >
      {children}
    </KYCContext.Provider>
  );
};

// Custom hook
export const useKYC = () => {
  const context = React.useContext(KYCContext);
  if (context === undefined) {
    throw new Error("useKYC must be used within a KYCProvider");
  }
  return context;
};
